import isNil from 'lodash/isNil'

export const Guards = {
  againstEmptyString: {
    isValid: (str: string | null | undefined): str is string => {
      if (isNil(str) || str.length === 0) {
        return false
      }
      return true
    },
    errorMsg: (name: string) => `"${name}" is null or undefined or empty string `,
  },
}
